import {
  createDocument,
  getDocuments,
  deleteDocument,
  updateDocument,
} from '../services/documents';
import { StartOcppTagsProps } from '../types/responses/StartOcppTags';

const normalizeOcppTagsResponse = (data: any): any => {
  if (!data) {
    return data;
  }

  if (Array.isArray(data)) {
    return { ocppTagList: data };
  }

  if (data.ocppTagList) {
    return data;
  }

  if (data.list) {
    return { ...data, ocppTagList: data.list };
  }

  return data;
};

const getOcppTags = async (
  searchInput = undefined,
  page = undefined,
  size = undefined,
  active = undefined,
): Promise<any> => {
  let url = 'ocpptags?';

  if (searchInput) {
    url += `searchInput=${searchInput}&`;
  }

  if (page !== undefined && size !== undefined) {
    url += `page=${page}&size=${size}&`;
  }

  if (active !== undefined) {
    url += `active=${active}&`;
  }

  url = url.endsWith('&') ? url.slice(0, -1) : url;

  const data = await getDocuments(url === 'ocpptags?' ? 'ocpptags' : url);
  return normalizeOcppTagsResponse(data);
};

const getOcppTagsCards = async (
  type,
  userPk = null,
  active = undefined,
): Promise<any> => {
  let url = `ocpptags?type=${type}`;

  if (userPk != null && typeof userPk !== 'boolean') {
    url += `&userPk=${userPk}`;
  }

  if (active !== undefined) {
    url += `&active=${active}`;
  }

  const data = await getDocuments(url);
  return normalizeOcppTagsResponse(data);
};

const createOcppTag = async (ocppTagForm) => {
  const data = await createDocument(ocppTagForm, 'ocpptags');
  return data;
};

const updateOcppTag = async (ocppTagForm, ocppTagPk) => {
  const data = await updateDocument(ocppTagPk, ocppTagForm, 'ocpptags');
  return data;
};

const deleteOcppTag = async (ocppTagPk): Promise<any> => {
  const data = await deleteDocument(ocppTagPk, 'ocpptags');
  return data;
};

const getOcppTag = async (ocppTagPk) => {
  const data = await getDocuments(`ocpptags/${ocppTagPk}`);
  return data;
};

const getTenantParentOcppTagByCPF = async (cpf): Promise<any> => {
  const data: any = await getDocuments(`ocpptags/tenant_parent/cpf/${cpf}`);
  return data;
};

const getUnknownOcppTags = async (): Promise<any> => {
  const data = await getDocuments('ocpptags/unknown');
  return data;
};

const approveUnknownOcppTag = async (ocppTagForm) => {
  const data = await createDocument(ocppTagForm, 'ocpptags/unknown');
  return data;
};

const deleteUnknownOcppTag = async (idTag): Promise<any> => {
  const data = await deleteDocument(idTag, 'ocpptags/unknown');
  return data;
};

const getStartOcppTags = async (
  searchInput: string = '',
): Promise<StartOcppTagsProps> => {
  const data: any = await getDocuments(
    `ocpptags/start?searchInput=${searchInput}`,
  );

  return data;
};

export {
  createOcppTag,
  getOcppTags,
  getOcppTagsCards,
  deleteOcppTag,
  getOcppTag,
  updateOcppTag,
  getTenantParentOcppTagByCPF,
  getUnknownOcppTags,
  approveUnknownOcppTag,
  deleteUnknownOcppTag,
  getStartOcppTags,
};
